import { service } from '../../../../helpers/http' 

export const ActionGetCompanies = ({ dispatch }, payload) => { 
    return service({
        module: 'domainCompany',
        action: 'getCompanies',
        payload: payload
    })
}

export const ActionPostCompanies = ({ dispatch }, payload) => {

    return service({
        module: 'domainCompany',
        action: 'postCompanies',
        payload: payload
    })
    
}

export const ActionPutCompanies = ({ dispatch }, payload) => {

    return service({
        module: 'domainCompany',
        action: 'putCompanies',
        payload: payload
    })
    
}

export const ActionDeleteCompanies = ({ dispatch }, payload) => {

    return service({
        module: 'domainCompany',
        action: 'deleteCompanies',
        payload: payload
    })
    
}
